import { FlexSection } from '../../../../containers/Pillbox/components';
import { Button } from '../../../../interaction/Buttons/Default Button/Button';
import { GoalCardActionItems } from '../../shared-types';

interface GoalCardActionsProps {
  actions: GoalCardActionItems[];
}

export const GoalCardActions = ({ actions }: GoalCardActionsProps) => {
  if (!actions) {
    return null;
  }

  return (
    <FlexSection sx={{ justifyContent: 'flex-end' }}>
      {actions.map(action => {
        return (
          <Button
            key={action.label}
            variant={action.isPrimary ? 'contained' : 'outlined'}
            onClick={action.onClick}
          >
            {action.label}
          </Button>
        );
      })}
    </FlexSection>
  );
};
